export const IMAGE_MAP_DROP = {
  'drop-appear': '/animations/png-sequences/spritesheet-appear.png',
  'drop-static': '/animations/png-sequences/box-static.png',
  'drop-open-common': '/animations/png-sequences/spritesheet-open-common.png',
  'drop-open-rare': '/animations/png-sequences/spritesheet-open-rare.png',
  'drop-open-legendary':
    '/animations/png-sequences/spritesheet-open-legendary.png',
};
